import React from 'react';

/**
 * Standard content block for legal/info pages (Privacy, About, How-to, Feedback).
 */
const LegalSection = ({ title, children, className = '' }) => {
  const classes = ['legal-section', className].filter(Boolean).join(' ');

  return (
    <section className={classes}>
      {title ? <h2>{title}</h2> : null}
      {children}
    </section>
  );
};

export default LegalSection;
